import { useEffect, useState } from 'react'

/**
 * Phone. The same 640 the app shell uses for its chat sheet — an anchored card
 * needs room beside the thing it is anchored to, and a phone has none.
 *
 * Distinct from `useIsMobile` (782px), which answers a different question: that one
 * picks between the toolbar's desktop and mobile layouts. Note this is NOT the
 * Tailwind `sm` breakpoint either — `sm` is 480px in this app's token set.
 */
export const PHONE_QUERY = '(max-width: 639px)'

export function useIsPhone(): boolean {
  const [isPhone, setIsPhone] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(PHONE_QUERY).matches
      : false,
  )
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(PHONE_QUERY)
    const handler = (e: MediaQueryListEvent) => setIsPhone(e.matches)
    // No re-sync here: the lazy initializer above already read the same query,
    // and every consumer mounts on the client.
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  return isPhone
}

export default useIsPhone
